import { defineComponent as _defineComponent } from 'vue'
import { useNewFeatures } from './new-features.composable';

export default /*#__PURE__*/_defineComponent({
  __name: 'CommunicationModal',
  setup(__props) {


const { showCommunicationModal, closeModal, newFeatureInfo } = useNewFeatures();


return { __sfc: true,showCommunicationModal, closeModal, newFeatureInfo }
}

})